var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvptp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 133.76 339.92",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m83.57 105.2v-35.06a16.68 16.68 0 0 1 4.9-11.82l32.77-32.76a6.69 6.69 0 0 0 0-9.46l-14.19-14.1a6.68 6.68 0 0 0 -9.44 0l-32.77 32.68a50.12 50.12 0 0 0 -14.69 35.46v35.06m0 0a66.89 66.89 0 0 0 .25 129.58l-.25-.06v2.1 33a16.65 16.65 0 0 1 -4.9 11.82l-32.76 32.72a6.69 6.69 0 0 0 0 9.46l14.19 14.18a6.68 6.68 0 0 0 9.45 0l32.76-32.8a49.79 49.79 0 0 0 14.69-35.46v-32.91-2.11l-.29.07a66.88 66.88 0 0 0 .29-129.59",
    fill: "#5fc1c8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.86,
    cy: 169.96,
    fill: "#fff",
    r: 33.43
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvptp);
export default __webpack_public_path__ + "static/media/avptp.605e5dd3.svg";
export { ForwardRef as ReactComponent };